import React from 'react';
import { useNavigate } from 'react-router-dom';
import LogoutButton from "./LogoutButton";

interface NavBarProps {
    isLoggedIn?: boolean;
    username?: string | null;
    role?: string | null;
    setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
}

const NavBar: React.FC<NavBarProps> = ({ isLoggedIn, username, role, setIsLoggedIn}) => {
    const navigate = useNavigate();

    return (
        <nav style={{ padding: 16, borderBottom: '1px solid #ccc', display: 'flex', justifyContent: 'space-between' }}>
            {isLoggedIn && username ? (
                <>
                    <span>{username}님, 로그인 중입니다.</span>
                    <div style={{ display: 'flex', gap: 8 }}>
                        {role === 'ROLE_SERVER_ADMIN' && (
                            <button type="button" onClick={() => navigate('/admin/store-owners')}>
                                상점주인 관리
                            </button>
                        )}
                        <LogoutButton
                            onLogoutSuccess={() => {
                                setIsLoggedIn(false);
                                navigate('/login');
                            }}
                        />
                    </div>
                </>
            ) : (
                <button onClick={() => navigate('/login')}>로그인</button>
            )}
        </nav>
    );
};

export default NavBar;
